import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { getAllCases, type Case, type CaseGrade, type CaseStage } from "../index";
import { caseCheckKeys } from "./keys";
import { caseCheckQueryDefaults } from "./options";

type Options = Omit<UseQueryOptions<Case[]>, "queryKey" | "queryFn">;

export function useCaseCheckAllCases(
  params?: { stage?: CaseStage; grade?: CaseGrade },
  options?: Options,
) {
  return useQuery({
    queryKey: caseCheckKeys.casesAll(params),
    queryFn: () => getAllCases(params),
    ...caseCheckQueryDefaults,
    ...options,
  });
}
